import { render } from "./UserInfoPanel.vue?vue&type=template&id=22ebdc56"
import script from "./UserInfoPanel.vue?vue&type=script&lang=js"
export * from "./UserInfoPanel.vue?vue&type=script&lang=js"

import "./UserInfoPanel.vue?vue&type=style&index=0&id=22ebdc56&lang=scss"

import exportComponent from "E:\\公司项目\\双碳\\gdtt-front\\gdtt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__